import { EventNames } from "@analytics/enums";
import { PerformanceAnalyticsIDs } from "./enums";

export const STATUS_TO_EVENT_MAP: Record<number, EventNames> = {
  1: EventNames.PURCHASE_SUCCESS,
  2: EventNames.PURCHASE_FAILED,
};

export const TRANSACTIONS_DATA_KEY = "transactionsData";

export const TRANSACTION_STATUS_KEY = "transactionStatus";

export const APPS_FLYER_ONE_LINK_URL = "APPS_FLYER_ONE_LINK_URL";

export const APPS_FLYER_GOOGLE_PLAY_DIRECT_LINK_URL =
  "APPS_FLYER_GOOGLE_PLAY_DIRECT_LINK_URL";
export const APPS_FLYER_APP_STORE_DIRECT_LINK_URL =
  "APPS_FLYER_APP_STORE_DIRECT_LINK_URL";

export const CURRENCY = "USD";

export const PERFORMS_IDS = [
  PerformanceAnalyticsIDs.SWIPE,
  PerformanceAnalyticsIDs.OPEN_FROM_GRID,
];
